class HeaderHeight {
	constructor() {
        document.addEventListener('DOMContentLoaded', e => {
            this.calulate();
        });

        // We listen to the resize event
        window.addEventListener('resize', () => {
            this.calulate();
        });
	}
    calulate() {
        const headerMessageEl = document.getElementById('header-message');

        // Get the height of the element
        let hmh = headerMessageEl ? headerMessageEl.offsetHeight : 0;

        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--hmh', `${hmh}px`);
    }
}

export default new HeaderHeight();
